import styled from 'styled-components'

export const ContentWrapper = styled.div`
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`

export const HeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  width: 100%;
`

export const Title = styled.span`
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0.4px;
  flex-grow: 1;
  text-align: left;
`

export const UnitToggle = styled.div`
  flex-shrink: 0;
`
